import './aboutus.css';

export default function Aboutus() {
  return (
      <section className="about-section">
      <div className="about-image">
        <img src="./images/aboutusImg.jpeg" alt="About Pyramid" />
      </div>

      <div className="about-content">
        <h2>About Pyramid</h2>
        <h4>Specialized Industrial Coatings & Waterproofing Solutions</h4>
        <p>
          Pyramid is a specialized solution provider in industrial coatings,
          paints, all types of waterproofing and flooring supplier and service
          provider across all over India. Engaged in supply and application of
          polymeric-based high performance coatings, waterproofing, and flooring
          solutions for high-end engineering applications.
        </p>

        <p>
          We deal in a wide range of protective coatings, flooring solutions,
          waterproofing, and coating products for various applications. We
          provide protective and custom coatings for industrial and commercial
          applications.
        </p>

        <p>
          All the products are unique in their own class and offer
          <b> Techno-Commercial benefits</b> with value addition and cost saving.
        </p>

        <h5>Our Services include:</h5>
        <ul>
          <li>
            <b>Industrial Floors:</b> Polyurethane flooring, Electro Static
            Discharge flooring, Electrical Insulation coating, Epoxy flooring,
            Pu Concrete Flooring, Antiskid Car Parking & Staircase Flooring.
          </li>
          <li>
            <b>Terrace Waterproofing:</b> Heat insulation coating for warehouse
            roofs, Polyurea based terrace waterproofing, PU based terrace
            waterproofing, Acrylic based terrace waterproofing, Exterior
            building painting with waterproof coatings.
          </li>
          <li>
            <b>Industrial Structures:</b> Highly corrosive environment
            application, Normal structural coating, Coating for chimneys.
          </li>
        </ul>

        <p>
          Our strength lies in our ability to offer <b>technical guidance</b> to
          choose the correct coating for longer durability for specific
          conditions after site inspection.
        </p>

        <a href="#projects" className="about-link">
          View Our Solutions
        </a>
      </div>
    </section>
  );
}
